import { Component, Input, OnInit } from '@angular/core';
import { OpenFieldMetadataLego } from '../../shared/dto/open-field-metadata.lego';
import { OpenFieldTypeEnum } from '../../shared/dto/open-field-type.enum';

@Component({
  selector: 'wl-open-field-lego-summary',
  templateUrl: './open-field-lego-summary.component.html',
  styleUrls: ['./open-field-lego-summary.component.less'],
    standalone: false
})
export class OpenFieldLegoSummaryComponent implements OnInit {
  @Input() openFieldData: OpenFieldMetadataLego;
  openFieldType = OpenFieldTypeEnum;

  constructor() {}

  ngOnInit(): void {}
}
